"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoEmbedModal = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const DURATION = {
    CLASS: 'duration-500',
    TIME: 500,
};
function VideoEmbedModal({ embedContent, showModal, closeModal, }) {
    const customEmbedWrapperRef = (0, react_1.useRef)(null);
    const modalBGRef = (0, react_1.useRef)(null);
    const [transitionState, setTransitionState] = (0, react_1.useState)('hidden');
    (0, react_1.useEffect)(() => {
        if (showModal) {
            setTransitionState('fadeIn');
        }
    }, [showModal]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('fixed top-0 left-0 bottom-0 right-0 w-screen h-screen z-2000 overflow-x-hidden overflow-y-auto sm:py-0 sm:px-4', { block: showModal, hidden: !showModal }), onClick: (e) => {
                // @ts-ignore
                if (showModal && !customEmbedWrapperRef.current.contains(e.target)) {
                    setTransitionState('fadeOut');
                    setTimeout(() => {
                        closeModal();
                        setTransitionState('hidden');
                    }, DURATION.TIME);
                }
            }, role: "presentation" },
            react_1.default.createElement("div", { ref: customEmbedWrapperRef, style: {
                    aspectRatio: '16/9',
                }, className: (0, classnames_1.default)('relative mt-[10px] mx-[10px] sm:mx-auto sm:mt-[30px] sm:w-full sm:max-w-[600px] sm:max-h-[338px] md:max-w-[900px] md:max-h-[506px] transition transform', DURATION.CLASS, {
                    'opacity-100 translate-y-0': transitionState === 'fadeIn',
                    'opacity-0 -translate-y-16': transitionState !== 'fadeIn',
                }) },
                react_1.default.createElement("div", { className: "custom-embed video-player-embed", style: {
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                    } },
                    react_1.default.createElement("div", { className: "embed-responsive", dangerouslySetInnerHTML: { __html: embedContent } })))),
        showModal && (react_1.default.createElement("div", { ref: modalBGRef, className: (0, classnames_1.default)('fixed top-0 left-0 bottom-0 right-0 w-screen h-screen z-1000 bg-black transition-opacity', DURATION.CLASS, {
                'opacity-50': transitionState === 'fadeIn',
                'opacity-0': transitionState !== 'fadeIn',
            }) }))));
}
exports.VideoEmbedModal = VideoEmbedModal;
